import { Component, computed, inject, Input, OnInit, signal, Signal } from '@angular/core';
import { MarketplaceFacade, MarketplaceItemV2, MarketplaceV2Query } from '@fgb/core';
import { Location } from '@angular/common';
@Component({
  selector: 'fgb-marketplace-detail-page',
  templateUrl: './marketplace-detail-page.component.html',
  styleUrls: ['./marketplace-detail-page.component.scss'],
})
export class MarketplaceDetailPageComponent implements OnInit {
  @Input() id: number;
  private readonly marketplaceFacade = inject(MarketplaceFacade);
  private readonly marketplaceQuery = inject(MarketplaceV2Query);
  public readonly location = inject(Location);

  private marketplace: Signal<MarketplaceItemV2 | null> = signal(null);
  marketplaceItemType = computed(() => this.marketplaceQuery.resolveItemTypeContext(this.marketplace()!));

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItemById(this.id);
    this.marketplace = this.marketplaceQuery.getMarketplaceById();
  }
}
